import React, { Fragment, useState, useEffect } from "react"
import _ from "lodash"

import FormInput from "elements/Form/FormInput"
import FormSelect from "elements/Form/FormSelect"
import FormTextArea from "elements/Form/FormTextArea"

// import { useAddresses } from "./hooks/useAddresses"
import address from "./utils/philippineLocations.json"

const INPUT_HOUSE_NUMBER_PLACEHOLDER = "Unit/House No."
const INPUT_STREET_PLACEHOLDER = "Building, Street, Barangay"
const SELECT_PROVINCE_PLACEHOLDER = "Select province"
const SELECT_CITY_PLACEHOLDER = "Select city"

const Address = ({
  isRequired,
  fieldNames = [],
  values = {},
  isNationwide,
  helper,
  setFieldValue,
  hideRequired,
  errors,
  options,
  restrictedOption,
}) => {
  // const address = useAddresses()

  if (!!fieldNames && fieldNames?.length > 0) {
    fieldNames = fieldNames?.reduce((fieldNames, fieldName) => {
      let key = fieldName.split(".")
      key = key[key.length - 1]

      fieldNames[key] = fieldName
      return fieldNames
    }, {})
  }
  const {
    houseNumber,
    addressType,
    streetAddress,
    province,
    city,
    siteName,
    notes,
  } = fieldNames
  const [listOfProvince, setProvinces] = useState([])
  const [listOfCity, setListOfCity] = useState([])
  const shouldInputSite =
    !!siteName && _.get(values, addressType || "addressType") === "Office"

  useEffect(() => {
    initializeProvinces()
    const { Cities } = address.filter(
      (loc) => loc.Province === "Metro Manila"
    )[0]
    setListOfCity(sortCities(Cities))
    //eslint-disable-next-line
  }, [])

  const initializeProvinces = () => {
    let options = address.map(remapProvinces)
    const metroManila = options.filter(({ value }) => value === "Metro Manila")
    if (isNationwide) setProvinces(options)
    else setProvinces(metroManila)
  }

  const remapProvinces = ({ Province }) => ({
    value: Province,
    label: Province,
  })

  const sortCities = (cities) => {
    const sortedCities = cities
      .map(({ City }) => ({
        value: City,
        label: City,
      }))
      .sort((a, b) => {
        return a.value > b.value ? 1 : -1
      })

    return sortedCities
  }
  const handleOnChange = ({ value }, setFieldValue) => {
    const { Cities } = address.filter((loc) => loc.Province === value)[0]
    setListOfCity(sortCities(Cities))
    setFieldValue(city || "city", { value: "" })
  }

  return (
    <Fragment>
      {/* {addressType && (
        <AddressTypeChoices
          hideRequired={hideRequired}
          addressTypeName={addressType}
          values={values}
          restrictedOption={restrictedOption}
          setFieldValue={setFieldValue}
        />
      )} */}
      {shouldInputSite ? null : (
        <Fragment>
          {!!houseNumber ? (
            <FormInput
              name={houseNumber || "houseNumber"}
              label="House Number"
              helper={helper}
              placeholder={INPUT_HOUSE_NUMBER_PLACEHOLDER}
              isRequired={isRequired}
            />
          ) : null}
          <FormInput
            name={streetAddress || "streetAddress"}
            label="Street Address"
            helper={helper}
            placeholder={INPUT_STREET_PLACEHOLDER}
            isRequired={isRequired}
          />
          <FormSelect
            name={province || "province"}
            label="Province"
            isRequired={isRequired}
            value={_.get(values, province || "province")}
            placeholder={SELECT_PROVINCE_PLACEHOLDER}
            options={listOfProvince}
            onChange={handleOnChange}
            errors={errors}
          />
          <FormSelect
            name={city || "city"}
            label="City"
            placeholder={SELECT_CITY_PLACEHOLDER}
            value={_.get(values, city || "city")}
            isRequired={isRequired}
            options={listOfCity}
            errors={errors}
            isSelectable={true}
          />
          {notes && (
            <FormTextArea
              label="Delivery Notes"
              placeholder="Green gate"
              name={notes || "notes"}
              maxLength={150}
            />
          )}
        </Fragment>
      )}
    </Fragment>
  )
}

export default Address
